// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"773":"dac4869d","1966":"3f166929","3177":"13b9e512","8688":"496d5990"}[chunkId] + ".chunk.css";
};